module.exports = __webpack_public_path__ + "img/bgTop.ea958794.png";